let host_url = 'http://localhost:5000/';
if(process.env.NODE_ENV=="production"){
    // host_url = 'https://server-dot-aulart-tools.ue.r.appspot.com/';
    host_url = 'https://aulart-tools-backend-djmjefmz2a-ue.a.run.app/';
}

export const HOST_URL = host_url;